export const DAY_SET = "DAY_SET";
export const DAY_RESET = "DAY_RESET";